import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { ThemedView, ThemedText, Theme } from '@app/theme'
import BankIcon from '@app/assets/svg/BankIcon'
import Button from '@app/sharedComponents/Button/Button'
import { useTheme } from '@shopify/restyle'

const ConfirmReAddSheet = ({customerName , onContinue } : {customerName : string , onContinue : () => void}) => {
  const { colors } = useTheme<Theme>();
  return (
    <ThemedView paddingHorizontal='lg' paddingVertical='xl'>
        <ThemedView alignItems='center' justifyContent='center' mb='md'>
            <BankIcon />
        </ThemedView>
      <ThemedText textAlign='center' variant='h5s' mb='lg' color='text-primary'>Link bank account again</ThemedText>
      <ThemedText mb='lg' textAlign='center' variant='b3r' color='text-secondary'>Proceed to link bank account that belongs to {'\n'} {customerName}</ThemedText>
      <Button size='MD' label='Continue' handlePress={onContinue} bg={colors['bg-action-primary']} textColor={colors['text-primary']} />
    </ThemedView>
  )
}

export default ConfirmReAddSheet

const styles = StyleSheet.create({})